import axios from "axios";

/**
 * TrackService class to handle track-related API calls and authentication.
 */
class TrackService {
  static BASE_URL = process.env.REACT_APP_BASE_URL1;



  static async getAllTracks() {
    try {
      const response = await axios.get(`${TrackService.BASE_URL}/admin/api/track/get-all-tracks`);
      return response.data;
    } catch (err) {
      console.error("Error fetching track details :", err);
      throw err;
    }
  }

}

export default TrackService;
